/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box } from "@mui/material"

export const DiscountLogPageContainer = styled('div')({
  width: '100%',
  overflowX: 'hidden',
})

export const ActionContainer = styled(Box)(({ action }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getColorCode(action)}20`,
  color: getColorCode(action),
}));

const getColorCode = (action) => {
  switch (action) {
    case 'create':
      return '#fba045'
    case 'update':
      return '#61b2fa'
    case 'destroy':
      return '#f64246'
  }
}
